// Translations index
import { en } from './en';
import { fr } from './fr';
import { es } from './es';

export const translations = {
  en,
  fr,
  es
};

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' }
];

export const defaultLanguage = 'en';

// Helper function to get nested translation value
export const getTranslation = (translations, key, fallback = key) => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // Debug log for missing translations
      if (key.startsWith('offers.') || key.startsWith('cvs.') || key.startsWith('notes.')) {
        console.warn(`[getTranslation] Missing key: ${key} at level: ${k}`, {
          currentValue: value,
          availableKeys: value ? Object.keys(value) : null,
          fullPath: keys,
          currentLevel: k
        });
      }
      return fallback;
    }
  }
  
  // Return the value as is if it's a string or array
  if (typeof value === 'string') {
    return value;
  } else if (Array.isArray(value)) {
    // Allow arrays to be returned for list translations
    return value;
  } else if (typeof value === 'object' && value !== null) {
    // If value is an object (but not an array), return the fallback to avoid React rendering errors
    console.warn(`[getTranslation] Translation key "${key}" points to an object, not a string or array`, value);
    return fallback;
  }
  
  return value !== undefined && value !== null ? String(value) : fallback;
};

// Helper function to get language from browser or localStorage
export const getInitialLanguage = () => {
  // 1. Check localStorage first
  const savedLanguage = localStorage.getItem('preferredLanguage');
  if (savedLanguage && supportedLanguages.some(lang => lang.code === savedLanguage)) {
    return savedLanguage;
  }
  
  // 2. Check browser language
  const browserLanguage = navigator.language.split('-')[0]; // Get language code only (en from en-US)
  if (supportedLanguages.some(lang => lang.code === browserLanguage)) {
    return browserLanguage;
  }
  
  // 3. Fallback to default
  return defaultLanguage;
};